import { render, staticRenderFns } from "./ClientManagement.vue?vue&type=template&id=78aa8c93&"
import script from "./ClientManagement.vue?vue&type=script&lang=js&"
export * from "./ClientManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports